export default function mergeStyles(...args) {
  return Object.assign(
    {},
    ...args.filter(Boolean), // Only include truthy style objects
  );
}
